import { validateForm } from "utils/Validations";
import { object, string } from "yup";

const validationSchema = object({
  email: string()
    .nullable()
    .optional()
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
      message: "The email id you entered is not valid.",
      excludeEmptyString: true,
    }),
  mobile: string()
    .nullable()
    .optional()
    .matches(/^\d{10}$/, {
      message: "Mobile Number must be 10 digits",
      excludeEmptyString: true,
    }),
  annuitantTaxId: string()
    .min(9, "Tax ID must be 9 digits")
    .max(9, "Tax ID must be 9 digits")
    .required("Tax ID is required"),
  annuitantFirstName: string().min(1).required("First Name is required"),
  annuitantLastName: string().min(1).required("Last Name is required"),
  annuitantAddressLine1: string().min(1).required("Address Line 1 is required"),
  annuitantCity: string().min(1).required("City is required"),
  annuitantZipCode: string()
    .transform((val) => (val ? val.replace("-", "") : ""))
    .test(
      "len",
      "Zip Code must be either 5 or 9 digits.",
      (val) => !val || val.length === 5 || val.length === 9
    )
    .matches(/^\d*$/, "Zip is invalid")
    .optional(),
  annuitantEmailAddress: string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "The email id you entered is not valid."
    )
    .required("Email is required"),
  annuitantPhoneNumber: string()
    .min(10, "Mobile Number must be 10 digits")
    .max(10, "Mobile Number must be 10 digits")
    .required("Mobile Number is required"),
});

export const validate = async (value, field) => {
  let payload = {};
  payload[field] = value;
  const error = await validateForm(payload, validationSchema);
  return error[field];
};
